const { lazy } = require("react");

const Dashboard = lazy(() => import("./Dashboard"));
const Sensor = lazy(() => import("./Sensor"));
const Reports = lazy(() => import("./Reports"));
const Alerts = lazy(() => import("./Alerts"));

export { Dashboard, Sensor, Reports, Alerts };